import { useMutation } from '@tanstack/react-query';

import { HttpClient } from '@/network/HttpClient';

type PurchaseOnlineCardParams = {
  purchaseUrl: string;
  online_payment_key_id: number;
};

export const usePurchaseOnlineCardMutation = () =>
  useMutation({
    mutationFn: (params: PurchaseOnlineCardParams) =>
      HttpClient.request<{ payment_url: string }>({
        method: 'POST',
        url: params.purchaseUrl,
        data: { online_payment_key_id: params.online_payment_key_id },
      }),
  });
